import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
class Home extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div className="hero">
                    <div className="spacer"></div>
                    <div className="hero-align row">
                        <div className="col-md-6">
                            <div className="inner-align">
                                <h3>Tap the app</h3>
                                <h1>Get a Ride</h1>
                                <p>
                                    We’ve got a sure helpline you can call! Towva is the new and innovative app solution you can use to get Tow Trucks anytime, anywhere!
                                </p>
                                <div className="cat-sect">
                                    <div className="cat-downloads">
                                        <div data-aos="zoom-in" data-aos-delay="100" data-aos-duration="400">
                                        <a href="https://portal.towva.co/user_app"><img src={require("./../images/play-store.png")} width="100%" alt=""/></a>
                                        </div>
                                        <div></div>
                                        <div data-aos="zoom-in" data-aos-delay="300" data-aos-duration="400">
                                            <a href="https://portal.towva.co/user_app"><img src={require("./../images/app-store.png")} width="100%" alt=""/></a>
                                        </div>
                                    </div>
                                    <Link to="/trucker-registration"><button data-aos="fade-up" data-aos-delay="600" data-aos-duration="700">Register Now</button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="hero-image" data-aos-delay="900" data-aos="fade-left">
                                <img src={require("./../images/hero-van.png")} width="100%" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container cent bottom-pad">
                    <h2>Why use Towva?</h2>
                    <div className="row">
                        <div className="col-md-4" data-aos="fade-up">
                            <div className="why-img">
                                <img src={require("./../images/icon-efficient.jpg")} width="100%" alt=""/>
                            </div>
                            <h4>Fast and Cost-Effective</h4>
                            <p>
                                One click on the app guarantees you a quick response and the relocation of your vehicle to your chosen destination at an affordable rate.
                            </p>
                        </div>
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="why-img">
                                <img src={require("./../images/icon-secure.jpg")} width="100%" alt=""/>
                            </div>
                            <h4>Safety First</h4>
                            <p>
                                Don’t put yourself in Harm’s way, get your car off that busy highway or that lonely road in the dead of night with a simple request on the Towva app.
                            </p>
                        </div>
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="400">
                            <div className="why-img">
                                <img src={require("./../images/icon-reliable.jpg")} width="100%" alt=""/>
                            </div>
                            <h4>Reliable</h4>
                            <p>
                                We all know how unreliable freelance artisans can be. Let us help you book a sure tow vehicle that won’t let you down or keep you waiting indefinitely.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="blue-sect">
                    <div className="container-personal">
                        <h2>About Us</h2>
                        <div className="row">
                            <div className="col-md-6" data-aos="zoom-in">
                                <div className="about-img">
                                <img src={require("./../images/toy-truck.png")} width="100%" alt=""/></div>
                            </div>
                            <div className="col-md-6">
                                <div>
                                    <p>
                                        We bring you Towva.co, the app for real-time tow-vehicle hailing. Just by clicking a button, you can get yourself a tow vehicle that’s safe, reliable and won’t charge you an arm and a leg! We 
                                        believe that you shouldn’t have to stress yourself or put yourself at risk because of your vehicle. 
                                    </p>
                                    <p>
                                        This is why our primary mission is to provide the average person with a quick and easy option 
                                        anywhere you are! Plus, you’re also enabling tow vehicle drivers to support their families with a more steady income!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
    componentDidMount(){
        window.scrollTo(0, 0);
        
    }
}
 
export default Home;